"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reconcilePackagesPackageSchema = exports.pkgFunctionsSchema = exports.pkgPinoutSchema = exports.pkgParametersSchema = exports.sequenceGateSchema = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const zod_1 = require("zod");
exports.sequenceGateSchema = zod_1.z.unknown().optional();
exports.pkgParametersSchema = zod_1.z.record(zod_1.z.string(), zod_1.z
    .object({
    value: zod_1.z.string().nullable(),
    variance: zod_1.z.string().nullable(),
    notSpecified: zod_1.z.boolean().optional(),
})
    .transform((entry) => (entry.notSpecified === true ? { ...entry, value: null, variance: null } : entry)));
exports.pkgPinoutSchema = zod_1.z.record(zod_1.z.string(), zod_1.z.string().array());
exports.pkgFunctionsSchema = sigma_engine_shared_1.IComponentFunctionSchema.array();
exports.reconcilePackagesPackageSchema = zod_1.z.object({
    boundaries: sigma_engine_shared_1.ComponentBoundarySchema.array(),
    functions: exports.pkgFunctionsSchema,
    modes: sigma_engine_shared_1.ModeBaseSchema.array(),
    parameters: exports.pkgParametersSchema,
    pinout: exports.pkgPinoutSchema,
    resources: sigma_engine_shared_1.IComponentResourceSchema.array(),
    sigmaModelType: zod_1.z.string(),
    signals: sigma_engine_shared_1.SignalSchema.array(),
});
//# sourceMappingURL=misc.js.map